// extracted by mini-css-extract-plugin
export default {"trigger":"_167e5","skeleton-progress":"LRs9C"};